<template>
  <component :is="component" :filterData="filterData" :paginationData="paginationData" v-if="component"/>

</template>

<script>
export default {
  name: "BoardFilterLink",
  mixins: [],
  components: {},
  provide() {
    return {}
  },
  props: {
    filterLayout: {},
    filterData: {
      default: () => {
      }
    },
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      }
    },
  },
  data() {
    return {
      component: null,

    }
  },
  created() {
  },
  mounted() {
    this.filterLoader();

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    loader() {
      if (!this.filterLayout) {
        return null
      }
      return () => import(`@/template/board/filter/${this.filterLayout}`)
    },
  },
  methods: {
    filterLoader() {
      this.loader()
          .then(() => {
            this.component = () => this.loader()
          })
          .catch(() => {
            this.component = () => import('@/template/board/filter/BoardFilterDefaultLayout')
          })
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>